const SelectDropdownIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      position: 'absolute',
      right: 16,
      top: 'calc(50% - 12px)', // vertically centered tweak
      pointerEvents: 'none',
    }}
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.3183 15.9181C12.2184 15.9631 12.1101 15.9863 12.0005 15.9863C11.8909 15.9863 11.7826 15.9631 11.6827 15.9181C11.5829 15.8731 11.4937 15.8074 11.4211 15.7253C11.4211 15.7254 11.4211 15.7253 11.4211 15.7253L5.33161 8.84387C5.14861 8.63707 5.1679 8.32108 5.3747 8.13808C5.5815 7.95508 5.89749 7.97437 6.08049 8.18117L12.0005 14.8711L17.92 8.18119C18.103 7.97438 18.419 7.95508 18.6258 8.13806C18.8326 8.32105 18.8519 8.63705 18.6689 8.84386L12.58 15.7253C12.5074 15.8073 12.4182 15.873 12.3183 15.9181Z"
      fill="black"
    />
  </svg>
);

export default SelectDropdownIcon;
